export const imageBreakpoints = [400, 800, 1600, 3200]

export const normalizeImageSize = ({width, height}: { width, height }, nativeImageSize?: { width?: number, height?: number }) => {
  if (width >= height) {
    const aspectRatio = (nativeImageSize?.height ?? height) / (nativeImageSize?.width ?? width),
      newWidth = imageBreakpoints.find(v => v >= width)

    if (newWidth === -1) return {width, height}
    return {width: newWidth, height: newWidth * aspectRatio}
  } else {
    if (width >= height) {
      let aspectRatio = (nativeImageSize?.width ?? width) / (nativeImageSize?.height ?? height),
        newHeight = imageBreakpoints.find(v => v >= height)

      if (newHeight === -1) return {width, height}
      return {width: newHeight * aspectRatio, height: newHeight}
    }
  }
}


// WEBPACK FOOTER //
// ./src/stores/imageBreakpoints.ts